/* @flow */
import * as React from 'react';

const InstagramWhite = props => (
  <svg width={20} height={20} viewBox="0 0 20 20" {...props}>
    <path
      stroke="none"
      strokeWidth={1}
      fill="#FFFFFF"
      fillRule="evenodd"
      d="M13.6,19.2 L5.6,19.2 C2.509,19.196 0.004,16.691 0,13.6 L0,5.6 C0.004,2.509 2.509,0.004 5.6,0 L13.6,0 C16.691,0.004 19.196,2.509 19.2,5.6 L19.2,13.6 C19.196,16.691 16.691,19.196 13.6,19.2 Z M5.6,1.6 C3.392,1.603 1.603,3.392 1.6,5.6 L1.6,13.6 C1.603,15.808 3.392,17.597 5.6,17.6 L13.6,17.6 C15.808,17.597 17.597,15.808 17.6,13.6 L17.6,5.6 C17.597,3.392 15.808,1.603 13.6,1.6 L5.6,1.6 L5.6,1.6 Z M9.6,14.4 C6.949,14.4 4.8,12.251 4.8,9.6 C4.8,6.949 6.949,4.8 9.6,4.8 C12.251,4.8 14.4,6.949 14.4,9.6 C14.397,12.25 12.25,14.397 9.6,14.4 L9.6,14.4 Z M9.6,6.4 C7.833,6.4 6.4,7.833 6.4,9.6 C6.4,11.367 7.833,12.8 9.6,12.8 C11.367,12.8 12.8,11.367 12.8,9.6 C12.8,8.751 12.463,7.937 11.863,7.337 C11.263,6.737 10.449,6.4 9.6,6.4 Z M15.206,3.994 C15.206,4.435 14.848,4.794 14.406,4.794 C13.965,4.794 13.606,4.435 13.606,3.994 C13.606,3.552 13.965,3.194 14.406,3.194 C14.848,3.194 15.206,3.552 15.206,3.994 Z"
    />
  </svg>
);

export default InstagramWhite;



// WEBPACK FOOTER //
// ./src/assets/images/icons/instagram-white.js